import * as React from 'react';
import {observer} from "mobx-react-lite";
import UserStore from "../stores/user";
import {useParams} from "react-router-dom"
import UserDetails from "../components/UserDetails";

const UsersDetailsPage = observer(function UsersDetailsPage(props: { store: UserStore }) {
    const params: { id: string } = useParams()

    if (!props.store.userData[params.id]) {
        props.store.loadDetails(params.id)
    }

    return <div className="page-contents">
        {
            props.store.loading ?
                'loading...' :
                <UserDetails data={props.store.userData[params.id].data}/>
        }
    </div>
})

export default UsersDetailsPage